/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import {getState, getConfig} from '../../twd/twd'
import useBenchmarks from './use-benchmarks'
import useOffers from './use-offers'


export const RATINGS = [
    {value:'AAA', label:'Aaa/AAA'},
    {value:'AA', label:'Aa/AA'},
    {value:'A', label:'A/A'},
    {value:'BBB', label:'Baa/BBB'},
    {value:'HY', label:'HY'}
]
export const RATING_VALUES = RATINGS.map(a => a.value)

getState('municipals.scatter-graph', {
    ratings: [].concat(RATING_VALUES),
    activeState: '',
    activeStateTs: 0
})

const colors = [
    '#FFA21F',
    '#FF9C9C',
    '#B7C9ED',
    '#241056',
    '#3991FF',

    '#FF5593',
    '#0065E3',
    '#FFA120',
    '#65ECED',
    '#5627D8',
    '#63AD02'
]

export const Context = React.createContext()
export const ContextProvider = ({children}) => {

    const state = getState('municipals.scatter-graph')
    const [ratings, setRatings_] = React.useState(state.value.ratings || [].concat(RATING_VALUES))
    const setRatings = React.useCallback((m) => {
        state.set({ratings:m})
        setRatings_(m)
    }, [])

    const defaultState = getConfig('account_states.0.stateOfResidence','')
    const [activeState, setActiveState_] = React.useState(state.value.activeStateTs ? state.value.activeState : defaultState)
    const setActiveState = React.useCallback((m) => {
        state.set({activeState:m, activeStateTs:Date.now()})
        setActiveState_(m)
    }, [])

    const benchmarks = useBenchmarks()
    const offers = useOffers({activeState})

    return <Context.Provider value={{
        RATINGS,
        RATING_VALUES,
        ratings, setRatings,
        activeState, setActiveState,
        colors,
        ...benchmarks,
        ...offers
    }}>{children}</Context.Provider>
}
export default () => React.useContext(Context)

